if (Number.parseFloat === undefined) {
  Number.parseFloat = window.parseFloat;
}

if (Number.parseInt === undefined) {
  Number.parseInt = window.parseInt;
}

if (Number.isNaN === undefined) {
  Number.isNaN = window.isNaN; // eslint-disable-line
}



//////////////////
// WEBPACK FOOTER
// ./config/polyfills/number.js
// module id = 209
// module chunks = 0